import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_STUDENT_BY_ENROLLMENT_STATUS } from "../Schema/Dashboard";

const useGetStudentByEnrollmentStatus = ({ page, limit, status, payAs }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  // console.log("fitlerType::", fitlerType)

  const { refetch } = useQuery(GET_STUDENT_BY_ENROLLMENT_STATUS, {
    variables: {
      page,
      limit,
      status,
      payAs,
    },
    onCompleted: ({ getStudentByEnrollmentStatus }) => {
      setTableData(getStudentByEnrollmentStatus?.students || []);
      setTotalCount(getStudentByEnrollmentStatus?.totalCount);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [page, limit, status, payAs]);

  return { loading, tableData, totalCount };
};

export default useGetStudentByEnrollmentStatus;
